import { parsePhoneNumber } from "libphonenumber-js";

import { ModelMapper } from "@api/mappers/mappers.types";

import { getLocale } from "@utils/configuration/aem";
import { Countries, CustomerTypes } from "@utils/enums";

import { CustomerApiModel } from "lib/@types/service/customer/customer.api.model";

import { CustomerModel } from "./@types/customer.model";
import { UpdateCustomerRequest } from "./customer.types";

const parsePhone = (phoneNumber?: string | null) => {
    let phone;
    let phonePrefix;

    if (phoneNumber) {
        try {
            const parsedNumber = parsePhoneNumber(phoneNumber);

            phone = parsedNumber.nationalNumber;
            phonePrefix = parsedNumber.countryCallingCode;
        } catch (_) { }
    }

    return { phone, phonePrefix };
};

export const CustomerMapper: ModelMapper<
    CustomerApiModel,
    CustomerModel
> = model => {
    const { phone, phonePrefix } = parsePhone(model.phone);

    return {
        bonusCardRequested: model.bonusCardRequested,
        email: model.email,
        guest: model.guest,
        bonusCardNumber: model.bonusCardNumber,
        eBonusCardNumber: model.eBonusCardNumber,
        firstName: model.firstName,
        isB2BClient: !!(model.companyName && model.vatNr),
        requestInvoice: model.requestInvoice,
        favouriteStoreId: model.favouriteStoreId,
        companyName: model.companyName,
        customerType: model.customerType as CustomerTypes,
        lastName: model.lastName,
        phone,
        phonePrefix: phonePrefix ? `+${phonePrefix}` : undefined,
        vatNr: model.vatNr?.substring(2),
        vatNrPrefix: model.vatNr?.substring(0, 2) || Countries.BE,
        language: model.language?.toLowerCase(),
        dateOfBirth: model.dateOfBirth,
        receiveSms: model.receiveSms,
        newsLetterSubscribed: model.newsLetterSubscribed,
        cartsMerged: model.cartsMerged,
        hasOrders: model.hasOrders,
    };
};

const getVatData = (customer: CustomerModel) => {
    if (customer.customerType !== CustomerTypes.B2B || !customer.vatNr) {
        return {};
    }

    return {
        vatNr: `${customer.vatNrPrefix}${customer.vatNr}`,
        companyName: customer.companyName,
    };
};

export const UpdateCustomerMapper: ModelMapper<
    CustomerModel,
    UpdateCustomerRequest
> = model => {
    const vatData = getVatData(model);

    return {
        firstName: model.firstName,
        lastName: model.lastName,
        bonusCardRequested: model.bonusCardRequested,
        customerType: model.customerType,
        email: model.email,
        guest: model.guest,
        phone:
            model.phone && model.phonePrefix
                ? `${model.phonePrefix}${model.phone}`
                : null,
        bonusCardNumber: model.bonusCardNumber || model.eBonusCardNumber || null,
        vatNr: vatData.vatNr || null,
        companyName: vatData.companyName || null,
        dateOfBirth: model.dateOfBirth || null,
        language: model.language || getLocale(false),
        favouriteStoreId: model.favouriteStoreId || null,
        newsLetterSubscribed: model.newsLetterSubscribed,
        receiveSms: model.receiveSms,
        requestInvoice: model.requestInvoice,
    };
};
